export interface FeatureIdLike {
    id?: string | number | null;
    featureid?: string | number | null;
}

export function normalizeFeatureId(value: unknown): string | null {
    if (value == null) return null;
    const normalized = String(value).trim();
    return normalized.length > 0 ? normalized : null;
}

export function getSelectedFeatureId(selectedFeature: FeatureIdLike | null | undefined): string | null {
    if (!selectedFeature) return null;
    return normalizeFeatureId(selectedFeature.id ?? selectedFeature.featureid);
}

export function findFeatureBySelectedId<T extends FeatureIdLike>(
    features: readonly T[],
    selectedFeature: FeatureIdLike | null | undefined
): T | null {
    const selectedId = getSelectedFeatureId(selectedFeature);
    if (!selectedId) return null;

    return (
        features.find((feature) => {
            const featureId = normalizeFeatureId(feature.featureid ?? feature.id);
            return featureId === selectedId;
        }) ?? null
    );
}
